<template>
    <div id="product-detail-widget-component">
        <WidgetWrapperComponent
            :class="is_widget_open ? 'widget-full-height' : ''"
            :title="$t('product_report.detail_by_product')"
            id-widget="product-report-products"
            v-on:toggle="is_widget_open = $event"
        >
            <template v-slot:default>
                <v-simple-table class="stripe-date-table">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>{{ $t('product_report.color_code') }}</th>
                                <th>{{ $t('product_report.product_reference') }}</th>
                                <th class="text-right">{{ $t('product_report.dilution') }}</th>
                                <th class="text-right">{{ $t('product_report.bidons_consumed') }}</th>
                                <th class="text-right">{{ $t('product_report.ready_solution') }}</th>
                                <th class="text-right">{{ $t('product_report.water_used') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(product, index) in products" :key="product.key">
                                <td>
                                    <span class="d-flex align-center gap-1">
                                        <img v-if="canisterImage(product)" :src="canisterImage(product)" alt="canister" height="60" />
                                        <span v-else :style="{ backgroundColor: dotColor(product, index) }" class="legend-dot" />
                                        <span v-if="colorName(product)" class="text-capitalize">
                                            {{ colorName(product) }}
                                        </span>
                                    </span>
                                </td>
                                <td>{{ product.label }}</td>
                                <td class="text-right">{{ number(product.dilution_percent) }} %</td>
                                <td class="text-right">{{ product.bidons_consumed }}</td>
                                <td class="text-right">{{ number(product.solution_l) }} L</td>
                                <td class="text-right">{{ number(product.water_l) }} L</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="font-weight-bold">
                                <td colspan="3">{{ $t('product_report.total') }}</td>
                                <td class="text-right">{{ totals.bidons_consumed }}</td>
                                <td class="text-right">{{ number(totals.solution_l) }} L</td>
                                <td class="text-right">{{ number(totals.water_l) }} L</td>
                            </tr>
                        </tfoot>
                    </template>
                </v-simple-table>
            </template>
        </WidgetWrapperComponent>
    </div>
</template>

<script>
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import number from '@/mixin/number'
import utils from '@/mixin/utils'

// Named colors the backend may store as a label (couleur_cuve) rather than a hex value, mapped to
// the palette so the swatch matches the product's real color instead of a positional fallback.
const NAMED_COLORS = {
    bleu: '#3F51B5',
    blue: '#3F51B5',
    jaune: '#E4B93B',
    yellow: '#E4B93B',
    vert: '#4CAF50',
    green: '#4CAF50',
    rouge: '#E53935',
    red: '#E53935',
    orange: '#FB8C00',
    cyan: '#00ACC1',
    blanc: '#FFFFFF',
    white: '#FFFFFF',
    noir: '#111111',
    black: '#111111',
    gris: '#9E9E9E',
    gris_clair: '#9E9E9E',
    grey: '#9E9E9E',
    gray: '#9E9E9E',
}

const CANISTER_IMAGES = {
    bleu: 'blue',
    blue: 'blue',
    jaune: 'yellow',
    yellow: 'yellow',
    vert: 'green',
    green: 'green',
    rouge: 'red',
    red: 'red',
}

const PALETTE = ['#3F51B5', '#E4B93B', '#4CAF50', '#E53935', '#00ACC1', '#FB8C00']

export default {
    name: 'ProductDetailWidgetComponent',
    components: {
        WidgetWrapperComponent,
    },
    mixins: [number, utils],
    props: {
        products: {
            type: Array,
            required: true,
        },
        totals: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            is_widget_open: true,
        }
    },
    methods: {
        dotColor(product, index) {
            const key = product.color ? product.color.trim().toLowerCase() : null

            return product.color && product.color.startsWith('#')
                ? product.color
                : (key && NAMED_COLORS[key]) || PALETTE[index % PALETTE.length]
        },

        canisterImage(product) {
            const key = product.color ? product.color.trim().toLowerCase() : null
            const canister = key && key.startsWith('#') ? this.canisterFromHex(key) : key && CANISTER_IMAGES[key]

            return canister ? `/images/widget/suiclean/canister_${canister}.png` : null
        },

        canisterFromHex(hex) {
            const hue = this.hueFromHex(hex)

            return hue === null ? null : hue < 30 || hue >= 330 ? 'red' : hue < 90 ? 'yellow' : hue < 180 ? 'green' : 'blue'
        },

        colorName(product) {
            return product.color && !product.color.startsWith('#') ? product.color : ''
        },
    },
}
</script>
